<div class="row sub-change-without-login__row">
  <div class="col-12 sub-change-without-login__col">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('sub_change_intro')"
        [innerHTML]="translationService.getTranslation('sub_change_intro')"
        class="sub-change-without-login__intro"></h3>
  </div>
  <div class="col-12 mb-3 sub-change-without-login__col sub-change-without-login__col--description">
    <h4
      [innerHTML]="identified? translationService.getTranslation('sub_change_description') : translationService.getTranslation('unauthorized_provideInfo_description')"
      class="sub-change-without-login__description"></h4>
  </div>
</div>
<mat-card class="mt-3 sub-change-without-login__card">
  <mat-card-content class="sub-change-without-login__card-content">
    <div class="row sub-change-without-login__row">
      <div class="col-12 sub-change-without-login__col">
        @if (!identified) {
          <div class="col-12 sub-change-without-login__col sub-change-without-login__col--identification">
            <button mat-flat-button
                    class="btn btn-secondary sub-change-without-login__btn sub-change-without-login__btn--identification"
                    (click)="navigateToIdentification()"
                    [innerHTML]="translationService.getTranslation('button_toIdentificationForm')"></button>
          </div>
        }
        @if (isLoadingSub) {
          <div style="text-align: center;" class="sub-change-without-login__loading">
            <app-loading-spinner class="sub-change-without-login__spinner"></app-loading-spinner>
          </div>
        }
        <app-general-errors [errors]="errorsArr" class="sub-change-without-login__errors"></app-general-errors>
        @if (identified && !isLoadingSub && subs.length == 0) {
          <div class="mt-3 sub-change-without-login__no-subs"
               [innerHTML]="translationService.getTranslation('intro_noSubs')"></div>
        }
        @if (!isLoadingSub && subs.length > 0) {
          @for (sub of subs; track sub) {
            <mat-card appearance="outlined" class="mt-3 sub-change-without-login__sub-card">
              <div class="row m-3 sub-change-without-login__sub-row">
                <div
                  class="col-12 col-md-6 sub-change-without-login__sub-col sub-change-without-login__sub-col--details">
                  <mat-card-title class="sub-change-without-login__sub-title">{{ sub.productDescription }}
                  </mat-card-title>
                  @if (sub.subId) {
                    <mat-card-subtitle class="sub-change-without-login__sub-subtitle"
                                       [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.subId">
                    </mat-card-subtitle>
                  }
                  @if (sub.variantDescription) {
                    <mat-card-subtitle class="sub-change-without-login__sub-subtitle"
                                       [innerHTML]="translationService.getTranslation('order_edition') + ': ' + sub.variantDescription">
                    </mat-card-subtitle>
                  }
                  @if (sub.validDate) {
                    <mat-card-subtitle class="sub-change-without-login__sub-subtitle"
                                       [innerHTML]="translationService.getTranslation('period') + ': ' +
                        (sub.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' +
                        ((sub.validDate.validUntil) ? (sub.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))">
                    </mat-card-subtitle>
                  }
                  @if (sub.curDelivery) {
                    <mat-card-subtitle class="sub-change-without-login__sub-subtitle">
                      {{ sub.curDelivery.person.addressCodeDescription }}
                      {{ sub.curDelivery.person.firstname }}
                      {{ sub.curDelivery.person.lastname }},
                      {{ sub.curDelivery.address.city }},
                      {{ sub.curDelivery.address.street }} {{ sub.curDelivery.address.houseno | houseNoPipe }}
                    </mat-card-subtitle>
                  }
                </div>
                <div
                  class="col-12 col-md-6 sub-change-without-login__sub-col sub-change-without-login__sub-col--actions">
                  @let onlinePayment = isOnlinePayment(sub);

                  <mat-card-actions class="card-actions sub-change-without-login__sub-actions">
                    <button mat-raised-button color="primary"
                            (click)="onNewSubChange(sub)"
                            [innerHTML]="translationService.getTranslation('button_new_sub_change')"
                            [disabled]="onlinePayment"
                            class="sub-change-without-login__btn sub-change-without-login__btn--sub-change"></button>
                  </mat-card-actions>
                  @if (onlinePayment) {
                    <p *appApplyIfNotEmpty="translationService.getTranslation('subChange_impossible')" class="sub-change-without-login__warning text-warning text-end" id="sub-change-without-login-warning"
                       [innerHTML]="translationService.getTranslation('subChange_impossible')"></p>
                  }
                </div>
              </div>
              @if (sub && sub.subChanges && sub.subChanges.length > 0) {
                <mat-card-content class="sub-change-without-login__sub-changes-content">
                  <mat-accordion multi class="sub-change-without-login__sub-accordion">
                    @for (subChange of sub.subChanges; track subChange; let innerI = $index) {
                      <mat-expansion-panel class="sub-change-without-login__sub-expansion-panel">
                        <mat-expansion-panel-header class="sub-change-without-login__sub-expansion-header">
                          <mat-panel-title class="sub-change-without-login__sub-expansion-title"
                                           [innerHTML]="translationService.getTranslation('label_' + subChange.changeType.toString() + '_description')"></mat-panel-title>
                          <mat-panel-description class="sub-change-without-login__sub-expansion-description">
                            {{ subChange.validDate.validFrom | date: translationService.getTranslation('dateFormat') }}
                            {{
                              (subChange.validDate.validUntil && subChange.validDate.validUntil != subChange.validDate.validFrom) ?
                                ' - ' + (subChange.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : ''
                            }}
                          </mat-panel-description>
                        </mat-expansion-panel-header>
                        <ng-template matExpansionPanelContent class="sub-change-without-login__sub-expansion-content">
                        </ng-template>
                      </mat-expansion-panel>
                    }
                  </mat-accordion>
                </mat-card-content>
              }
            </mat-card>
          }
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
